import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetArticlesCategoriesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            "object": [
                {
                    "name": "Otra Categoria",
                    "title": "TItulo Otra Categoria",
                    "description": "Descripcion Otra Categoria",
                    "main_image": "main_image.jpg",
                    "white_logo_image": "white_logo_image.jpg",
                    "black_logo_image": "black_logo_image.jpg",
                    "banner_image": "banner_logo_image.jpg"
                },
                {
                    "name": "Categoria",
                    "title": "Titulo Categoria",
                    "description": "Descripcion Categoria",
                    "main_image": "main_image.jpg",
                    "white_logo_image": "white_logo_image.jpg",
                    "black_logo_image": "black_logo_image.jpg",
                    "banner_image": "banner_logo_image.jpg"
                }
            ],
            "errors": []
        }
    }

    articlesCategories() {
        return this.content().map(category => {
            return {
                name: category.name,
                title: category.title,
                description: category.description,
                mainImage: category.main_image,
                whiteLogoImage: category.white_logo_image,
                blackLogoImage: category.black_logo_image,
                bannerImage: category.banner_image,
            }
        });
    }
}